// Shared geometry for the two dashboard charts.
//
// Spec §5 requires the reaction timeline to sit aligned under the retention curve
// "so the two read together". That only works if both charts share an identical
// x-domain and identical horizontal padding — so the padding lives here, once,
// rather than as two constants that drift apart the first time someone tweaks one.
export function chartGeometry(input: { width: number; height: number; durationMs: number }) {
  const padLeft = 44;
  const padRight = 12;
  const padTop = 10;
  const padBottom = 22;

  const plotWidth = Math.max(1, input.width - padLeft - padRight);
  const plotHeight = Math.max(1, input.height - padTop - padBottom);
  // Guard the degenerate case: a test with no duration yet would otherwise divide
  // by zero and place every mark at NaN, which renders as an invisible chart with
  // no error to explain it.
  const durationMs = input.durationMs > 0 ? input.durationMs : 1;

  return {
    padLeft,
    padRight,
    padTop,
    padBottom,
    plotWidth,
    plotHeight,
    xForTime: (timeMs: number) =>
      padLeft + (Math.min(Math.max(timeMs, 0), durationMs) / durationMs) * plotWidth,
    widthForSpan: (spanMs: number) => Math.max(1, (spanMs / durationMs) * plotWidth),
    yForFraction: (fraction: number) => padTop + (1 - Math.min(Math.max(fraction, 0), 1)) * plotHeight,
    baselineY: padTop + plotHeight
  };
}
